import DB from 'offline/db'

// Port of api/fuel/app/classes/filter/package/games/game/data/rank.php
export default {
	run: function(filter, data, config, global) {
		global.rankPrevious = []
		if (!filter.source || (!filter.source.list && !filter.source['list.sorted'])) return

		var editionId = filter.source.list || filter.source['list.sorted']
		var currentRows = DB.query('SELECT list_id, list_edition_date FROM list_edition WHERE list_edition_id = ?', [editionId])
		if (!currentRows.length) return

		var previousRows = DB.query(
			'SELECT list_edition_index_games FROM list_edition WHERE list_id = ? AND list_edition_date < ? ORDER BY list_edition_date DESC, list_edition_id DESC LIMIT 1',
			[currentRows[0].list_id, currentRows[0].list_edition_date]
		)

		if (!previousRows.length || !previousRows[0].list_edition_index_games) return
		global.rankPrevious = String(previousRows[0].list_edition_index_games)
			.split(',')
			.map(function(id) { return parseInt(id, 10) })
			.filter(function(id) { return !!id })
	}
}
